import { BaseHubOptions } from "../../BaseHubOptions";

export class CashoutHubOptions extends BaseHubOptions {
	name: string = "Cashout";
	commonEventNames: string[] = ['ChannelUpdates']
}